// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"747362ae","80":"085f22dc"}[chunkId] + ".chunk.css";
};